// "Add to basket" on product cards (snippets/card-product-amplified.liquid). Adds one of the card's variant,
// refreshes the header basket count and tells the theme (and the free delivery game) that the basket changed.
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.amp-card__add');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.textContent.trim();
    btn.setAttribute('aria-busy', 'true');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { btn.textContent = res.body && res.body.description ? 'Sorry, ' + res.body.description.toLowerCase() : 'Could not add'; return; }
        var bubble = document.getElementById('cart-icon-bubble');
        var html = res.body.sections && res.body.sections['cart-icon-bubble'];
        if (bubble && html) {
          var tmp = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (tmp) bubble.innerHTML = tmp.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vp-quick-add' });
        btn.textContent = 'Added ✓';
      })
      .catch(function () { btn.textContent = 'Could not add'; })
      .then(function () {
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.textContent = label; }, 2200);
      });
  });
})();
